const ImageSlide=[
    {
        url:'computer.png',
        title:"Computer Engineering",
        follow:"142,765 Computer Engineers follow this"
    },
    {
        url:'connectivity.png',
        title:"Astronomy",
        follow:"349,890 Astronomers follow this"
    },
    {
        url:'tech.png',
        title:"Ethical Hacking",
        follow:"89,890 students follow this"
    },
]

export default ImageSlide;